import { render } from "./ParticipantsSidebar.vue?vue&type=template&id=50d9ece4&scoped=true"
import script from "./ParticipantsSidebar.vue?vue&type=script&lang=js"
export * from "./ParticipantsSidebar.vue?vue&type=script&lang=js"

import "./ParticipantsSidebar.vue?vue&type=style&index=0&id=50d9ece4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d9ece4"]])

export default __exports__